<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="1" :offset="0">
        <span>&nbsp;</span>
      </el-col>
      <el-col :span="3">
        <el-dropdown v-if="(id_project > 0) && (g_project.id_analysis_type > 0) && (g_examination_selected.status === 12)" style="width: 100%; margin-top: 6px; margin-bottom: 6px;">
          <el-button type="warning" size="small" style="width: 100%">
            Actions of Variants <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu v-if="id_biorole > 3" slot="dropdown">
            <el-dropdown-item v-if="vars_selected_tab != 'presel' && vars_selected_tab != 'sign' && g_examination.published.length === 0" icon="icofont-arrow-right" @click.native="preselect_vars($event)">Move to Preselected Variants</el-dropdown-item>
            <el-dropdown-item v-if="vars_selected_tab === 'presel' && g_examination.published.length === 0" icon="icofont-arrow-left" @click.native="unpreselect_vars($event)">Remove from Preselected Variants</el-dropdown-item>
            <el-dropdown-item v-if="vars_selected_tab != 'sign' && g_examination.published.length === 0" icon="icofont-prescription" divided @click.native="sign_out_vars($event)">Sign-out variants</el-dropdown-item>
            <el-dropdown-item v-if="vars_selected_tab != 'sign' && g_examination.published.length === 0" icon="icofont-law-document"  @click.native="sign_out_no_vars($event)">Sign out with NO variants</el-dropdown-item>
            <el-dropdown-item v-if="g_examination.published.length > 0" icon="icofont-ui-reply" @click.native="sign_out_vars_reset($event)">Sign-out RESET</el-dropdown-item>
            <el-dropdown-item v-if="g_examination.published.length > 0" icon="icofont-file-pdf" divided @click.native="make_report_vars($event, g_examination.sample_id)">Make Report - PDF File</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span v-else>&nbsp;</span>
      </el-col>

      <el-col :span="3">
        <el-dropdown style="width: 100%; margin-top: 6px;  margin-bottom: 6px;">
          <el-button type="primary" size="small" style="width: 100%">
            Export of Variants <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="icofont-listing-box" divided @click.native="export_setup_cols($event)">Select columns for export</el-dropdown-item>
            <el-dropdown-item icon="icofont-file-excel" divided @click.native="export_all_vars($event)">Export ALL Variants into XLSX File</el-dropdown-item>
            <el-dropdown-item icon="icofont-file-excel" @click.native="export_grid_vars($event)">Export Variants in Table into XLSX File</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>

      <el-col :span="11" :offset="1">
        <el-input v-if="vars_selected_tab != 'presel' && vars_selected_tab != 'sign'" placeholder="select column for filtering and insert value here ..." v-model="search_vars_by_value" class="input-with-select bottom_margin_5" size="small" @keyup.enter.native="search_vars_by">
          <el-select v-model="search_vars_by_select" size="small" slot="prepend" placeholder="Filter by:" style="width: 220px;">
            <el-option label="Position" value="1"></el-option>
            <el-option label="dbSNP" value="2"></el-option>
            <el-option label="Gene name" value="4"></el-option>
            <el-option label="COSMIC ID" value="3"></el-option>
            <el-option label="ID VAR" value="5"></el-option>
          </el-select>
          <el-button slot="append" icon="icofont-search-2" size="small" @click="search_vars_by" style="margin: 0px 30px;"></el-button>
          <el-divider slot="append" direction="vertical"></el-divider>
          <el-button slot="append" icon="el-icon-close" size="small" @click="search_vars_all" style="margin: 0px 0px;"></el-button>
        </el-input>
      </el-col>

      <el-col :span="24">
        <el-table
          ref="varsTable"
          :data="vars"
          row-key="id_ant"
          v-loading="loading_v"
          element-loading-text="Loading..."
          element-loading-spinner="icofont-refresh icofont-5x"
          element-loading-background="rgba(100, 100, 100, 0.5)"
          :default-sort="{prop: 'id_clinvar', order: 'ascending'}"
          border
          highlight-current-row
          @current-change="handleCurrentChange_v"
          @selection-change="handleSelectionChange_v"
          @sort-change="handleSortChange_v"
          style="width: 100%"
          size="mini"
          :row-class-name="tableRowClassNameVars"
          >
          <template slot="empty">
              <div v-if="loading_v">
              </div>
              <div v-else style="font-size: 20px; font-weight: 800; text-align: left">
                No variants found
              </div>
          </template>

          <el-table-column
            v-if="g_examination_selected.status === 12"
            key="selection"
            type="selection"
            width="45"
            >
          </el-table-column>

          <el-table-column key="sample_id"
            prop="sample_id"
            label="Sample"
            min-width="130"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">
              <span> {{ scope.row.sample_id }} </span> <br />
              <el-tooltip v-if="scope.row.description_v > ''" :content="scope.row.description_v" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" type="info">CM</el-tag>
              </el-tooltip>
              <el-tooltip v-if="scope.row.var_status === 2" content="Signed Out Variant" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" effect="dark" type="success">SO</el-tag>
              </el-tooltip>
              <el-tooltip v-if="scope.row.var_status === 1" content="Preselected Variant" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" effect="dark" type="warning">PS</el-tag>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="int_sa"
            prop="int_sa"
            label="Cl. A"
            width="65"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Internal classification by expert A"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">Cl. A</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.int_sa >= 0" slot-scope="scope">
              <el-tooltip
                :content="scope.row.user_name_a"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <el-button
                  :style="g_iclasses_style(scope.row.int_sa)"
                  size="small"
                  @click.native="click_modal_interpretation(scope.row.id_var, scope.row.int_sa, 'a', scope.row.description_v)"
                  >
                  {{ g_iclasses(scope.row.int_sa) }}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="int_sb"
            prop="int_sb"
            label="Cl. B"
            width="65"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Internal classification by expert B"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">Cl. B</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.int_sb >= 0" slot-scope="scope">
              <el-tooltip
                :content="scope.row.user_name_b"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <el-button
                  :style="g_iclasses_style(scope.row.int_sb)"
                  size="small"
                  @click.native="click_modal_interpretation(scope.row.id_var, scope.row.int_sb, 'b', scope.row.description_v)"
                >
                  {{ g_iclasses(scope.row.int_sb) }}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>>

          <el-table-column
            key="id_acmg_sig"
            prop="id_acmg_sig"
            label="ACMG 1"
            width="80"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Classification based on Genovesa algorithms"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">ACMG 1</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.id_acmg_sig > 0" slot-scope="scope">
              <el-popover
                placement="top-start"
                title="ACMG Description:"
                width="400"
                trigger="hover"
                :content="d_acmg_sigs[scope.row.id_acmg_sig]['mytext']"
              >
                <el-button
                  slot="reference"
                  :style="d_acmg_sigs[scope.row.id_acmg_sig]['mystyle']"
                  size="small"
                  @click.native="click_acmg($event, scope.row.id_var)"
                >
                  {{ d_acmg_sigs[scope.row.id_acmg_sig]["mynum"] }}
                </el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            key="id_acmg_genebe"
            prop="id_acmg_genebe"
            label="ACMG 2"
            width="80"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Classification based on GeneBe algorithms"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">ACMG 2</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.id_acmg_genebe > 0" slot-scope="scope">
              <el-popover
                placement="top-start"
                title="ACMG GENEBE Description:"
                width="400"
                trigger="hover"
                :content="d_acmg_sigs[scope.row.id_acmg_genebe]['mytext']"
              >
                <el-button
                  slot="reference"
                  :style="d_acmg_sigs[scope.row.id_acmg_genebe]['mystyle']"
                  size="small"
                  @click.native="click_acmg_genebe($event, scope.row.id_var)"
                >
                  {{ d_acmg_sigs[scope.row.id_acmg_genebe]["mynum"] }}
                </el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column key="id_clinvar"
            prop="id_clinvar"
            label="ClinVar"
            width="70"
            align="center"
            sortable="custom"
            >
            <template v-if="scope.row.clinvar_value >= 0" slot-scope="scope">
              <a v-if="scope.row.clinvar_value > 0" :href="mylink_clinsig(scope.row)" target="_blank">
                  <el-popover v-if="scope.row.clinvar_value === 5"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="danger" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else-if="scope.row.clinvar_value === 4"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="warning" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else-if="scope.row.clinvar_value === 3"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="info" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="success" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>
              </a>
              <div v-else>
                  <el-popover v-if="scope.row.clinvar_value === 5"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="danger" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else-if="scope.row.clinvar_value === 4"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="warning" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else-if="scope.row.clinvar_value === 3"
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="info" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>

                  <el-popover v-else
                    placement="top-start" title="Clinvar Description:" width="400" trigger="hover" :content="scope.row.clinvar_codes">
                    <el-tag slot="reference" type="success" class="hranaty">{{ scope.row.clinvar_value }}</el-tag>
                  </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="predictor"
            prop="predictor_status"
            label="Predict"
            width="70"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-popover v-if="scope.row.predictor_status >= 0" placement="top-start" width="400" trigger="hover">
                <template slot="default">PREDICTOR:
                  <a :href="scope.row.predictor_link" target="_blank"> {{ scope.row.predictor }} </a>
                  <br/>RANK SCORE: {{ scope.row.var_rank_score }}
                </template>
                <el-tag v-if="scope.row.cathegories === 5" slot="reference" type="danger" class="hranaty" @click="click_modal_predictors($event, scope.row.id_var)">{{ scope.row.cathegories }}</el-tag>
                <el-tag v-else-if="scope.row.cathegories === 4" slot="reference" type="warning" class="hranaty" @click="click_modal_predictors($event, scope.row.id_var)">{{ scope.row.cathegories }}</el-tag>
                <el-tag v-else-if="scope.row.cathegories === 3" slot="reference" type="info" class="hranaty" @click="click_modal_predictors($event, scope.row.id_var)">{{ scope.row.cathegories }}</el-tag>
                <el-tag v-else slot="reference" type="success" class="hranaty" @click="click_modal_predictors($event, scope.row.id_var)">{{ scope.row.cathegories }}</el-tag>
              </el-popover>
              <el-tag v-else slot="reference" type="success" class="hranaty"> NA </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            key="f_proj"
            prop="f_proj"
            label="Freq / Proj"
            width="100"
            align="center"
            >
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in this project (sequencing run)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Proj</span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <el-badge
                type="primary"
                :value="scope.row.e_proj"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_proj(scope.row)"
                >
                  {{ scope.row.f_proj }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column
            v-if="g_project.id_analysis_type === 1"
            key="f_wf1"
            prop="f_wf1"
            label="Freq / Som"
            width="100"
            align="center"
            >
            <!-- Header with improved tooltip -->
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in the whole subject (somatic samples database)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Som</span>
              </el-tooltip>
            </template>

            <!-- Row content -->
            <template slot-scope="scope">
              <el-badge
                type="info"
                :value="scope.row.e_wf1"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_subj(scope.row)"
                >
                  {{ scope.row.f_wf1 }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column
            v-if="g_project.id_analysis_type === 2"
            key="f_wf2"
            prop="f_wf2"
            label="Freq / Germ"
            min-width="110"
            align="center"
            >
            <!-- Header with improved tooltip -->
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in the whole subject (germline samples database)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Germ</span>
              </el-tooltip>
            </template>

            <!-- Row content -->
            <template slot-scope="scope">
              <el-badge
                type="info"
                :value="scope.row.e_wf2"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_subj(scope.row)"
                >
                  {{ scope.row.f_wf2 }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column key="gene_symbol"
            prop="gene_symbol"
            label="Gene"
            min-width="160"
            align="center"
            sortable="custom"
            >
            <template v-if="scope.row.gene_symbol > ''" slot-scope="scope">
                <a v-if="scope.row.gene_symbol > ''" :href="mylink_symbol(scope.row.gene_symbol)" target="_blank">{{ scope.row.gene_symbol }}</a> <br /> <a v-if="scope.row.feature > ''" :href="mylink_transcript(scope.row)" target="_blank">{{ scope.row.feature }}</a>
            </template>
          </el-table-column>

          <el-table-column
            key="a_891"
            prop="a_891"
            label="dbSNP"
            min-width="110"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">
              <!-- dbSNP link -->
              <a v-if="scope.row.a_891" :href="mylink_dbsnp(scope.row.a_891)" target="_blank">{{ scope.row.a_891 }}</a>

              <br />

              <!-- Tooltip with links -->
              <el-tooltip
                effect="light"
                placement="top"
                :visible-arrow="false"
                popper-class="custom-tooltip"
                :open-delay="500"
              >
                <template #content>
                  <div style="color: black;">

                  <!-- SNV / INDEL Variant Summary Header -->
                  <div style="margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #ddd;">

                    <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #006699; font-weight: bold;">
                      Variant
                    </h4>

                    <!-- Gene -->
                    <div style="margin-bottom: 6px;">
                      <b>Gene:</b>
                      <span v-if="scope.row && scope.row.gene_symbol" style="margin-left: 4px;">
                        <el-tag size="mini">
                          {{ scope.row.gene_symbol }}
                        </el-tag>
                      </span>
                      <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                        No gene
                      </span>
                    </div>

                    <!-- Variant type -->
                    <div style="margin-bottom: 6px;">
                      <b>Type:</b>

                      <!-- SNV -->
                      <el-tag
                        v-if="scope.row && scope.row.ref && scope.row.alt && scope.row.ref.length === 1 && scope.row.alt.length === 1"
                        size="mini"
                        type="info"
                        style="margin-left: 4px;"
                      >
                        SNV
                      </el-tag>

                      <!-- Deletion -->
                      <el-tag
                        v-else-if="scope.row && scope.row.ref && scope.row.alt && scope.row.ref.length > scope.row.alt.length"
                        size="mini"
                        type="danger"
                        style="margin-left: 4px;"
                      >
                        DEL
                      </el-tag>

                      <!-- Insertion -->
                      <el-tag
                        v-else-if="scope.row && scope.row.ref && scope.row.alt && scope.row.ref.length < scope.row.alt.length"
                        size="mini"
                        type="success"
                        style="margin-left: 4px;"
                      >
                        INS
                      </el-tag>

                      <!-- Complex INDEL / MNV -->
                      <el-tag
                        v-else-if="scope.row && scope.row.ref && scope.row.alt"
                        size="mini"
                        type="warning"
                        style="margin-left: 4px;"
                      >
                        INDEL / MNV
                      </el-tag>

                      <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                        Unknown
                      </span>
                    </div>

                    <!-- Transcript -->
                    <div style="margin-bottom: 6px;">
                      <b>Transcript:</b>
                      <span v-if="scope.row && scope.row.feature" style="margin-left: 4px;">
                        {{ scope.row.feature }}
                      </span>
                      <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                        No transcript
                      </span>
                    </div>

                    <!-- HGVSc -->
                    <div style="margin-bottom: 6px;">
                      <b>HGVSc:</b>
                      <span v-if="scope.row && scope.row.hgvsc_full" style="margin-left: 4px;">
                        {{ scope.row.hgvsc_full }}
                      </span>
                      <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                        No HGVSc
                      </span>
                    </div>

                    <!-- HGVSp -->
                    <div style="margin-bottom: 6px;">
                      <b>HGVSp:</b>
                      <span v-if="scope.row && scope.row.feature && scope.row.hgvsp" style="margin-left: 4px;">
                        {{ scope.row.feature }}:{{ scope.row.hgvsp }}
                      </span>
                      <span v-else-if="scope.row && scope.row.hgvsp" style="margin-left: 4px;">
                        {{ scope.row.hgvsp }}
                      </span>
                      <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                        No HGVSp
                      </span>
                    </div>

                  </div>

                    <!-- Reference Variant Quality Section -->
                    <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                      Reference Variant Quality
                    </h4>

                    <!-- UCSC (Session + Fallback) -->
                    <div style="margin-bottom: 8px;">

                      <!-- Primary: UCSC with Genovesa session -->
                      <a
                        v-if="scope.row && scope.row.chrom && scope.row.pos"
                        :href="mylink_ucsc_snv_session(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-globe" style="margin-right: 5px;"></i>
                        UCSC (Genovesa tracks)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">UCSC - No coordinates</span>

                      <!-- Secondary: fallback without session -->
                      <a
                        v-if="scope.row && scope.row.chrom && scope.row.pos"
                        :href="mylink_ucsc_snv_default(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center; margin-top: 4px;"
                      >
                        <i class="fa fa-life-ring" style="margin-right: 5px;"></i>
                        UCSC (default fallback)
                      </a>
                    </div>

                    <!-- Variant Database Section -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                        Variant Database
                      </h4>
                    </div>

                    <!-- Varsome links -->
                    <div style="margin-bottom: 8px;">
                      <template v-if="scope.row">
                        <div style="display: flex; align-items: center;">
                          <i class="fa fa-link" style="margin-right: 5px;"></i>
                          <span style="color: black; font-weight: bold; margin-right: 5px;">Varsome:</span>
                          <a :href="mylink_varsome(scope.row)" target="_blank" style="color: black; text-decoration: underline; margin-right: 5px;">
                            germline
                          </a>
                          <span>|</span>
                          <a :href="mylink_varsome_somatic(scope.row)" target="_blank" style="color: black; text-decoration: underline; margin-left: 5px;">
                            somatic
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <span style="color: gray; font-style: italic;">Varsome - No database evidence</span>
                      </template>
                    </div>

                    <!-- Franklin -->
                    <div style="margin-bottom: 8px;">
                      <template v-if="scope.row">
                        <div style="display: flex; align-items: center;">
                          <i class="fa fa-vial" style="margin-right: 5px;"></i>
                          <span style="color: black; font-weight: bold; margin-right: 5px;">Franklin:</span>
                          <a :href="mylink_franklin(scope.row)" target="_blank" style="color: black; text-decoration: underline; margin-right: 5px;">
                            germline
                          </a>
                          <span>|</span>
                          <a :href="mylink_franklin_somatic(scope.row)" target="_blank" style="color: black; text-decoration: underline; margin-left: 5px;">
                            somatic
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <span style="color: gray; font-style: italic;">Franklin - No database evidence</span>
                      </template>
                    </div>

                    <!-- GeneBe -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row"
                        :href="mylink_genebe(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-dna" style="margin-right: 5px;"></i> GeneBe
                      </a>
                      <span v-else style="color: gray; font-style: italic;">GeneBe - No database evidence</span>
                    </div>

                    <!-- gnomAD -->
                    <div style="margin-bottom: 8px;">
                      <template v-if="scope.row">
                        <div style="display: flex; align-items: center;">
                          <i class="fa fa-database" style="margin-right: 5px;"></i>
                          <a :href="gnomad(scope.row)" target="_blank" style="color: black; text-decoration: underline;">
                            gnomAD
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <span style="color: gray; font-style: italic;">gnomAD - No database evidence</span>
                      </template>
                    </div>

                    <!-- Oncology Knowledge Section -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                        Oncology Knowledge
                      </h4>
                    </div>

                    <!-- COSMIC -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row.a_501 && scope.row.a_501 !== ''"
                        :href="mylink_cosmic(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-globe" style="margin-right: 5px;"></i> COSMIC
                      </a>
                      <span v-else style="color: gray; font-style: italic;">COSMIC - No database evidence</span>
                    </div>

                    <!-- OncoKB -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row.mutpred && scope.row.mutpred !== ''"
                        :href="mylink_oncokb(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-chart-bar" style="margin-right: 5px;"></i> OncoKB
                      </a>
                      <span v-else style="color: gray; font-style: italic;">OncoKB - No database evidence</span>
                    </div>

                    <!-- PharmGKB -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.gene_symbol"
                        :href="mylink_pharmgkb(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-pills" style="margin-right: 5px;"></i> PharmGKB
                      </a>
                      <span v-else style="color: gray; font-style: italic;">PharmGKB - No data available</span>
                    </div>

                    <!-- Research Links section -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                        Research Links
                      </h4>
                    </div>

                    <!-- PubMed -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row.pubmed && scope.row.pubmed !== ''"
                        :href="mylink_pubmed(scope.row.pubmed)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-book-medical" style="margin-right: 5px;"></i> PubMed
                      </a>
                      <span v-else style="color: gray; font-style: italic;">PubMed - No database evidence</span>
                    </div>

                    <!-- Google Scholar -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row"
                        :href="mylink_google_scholar(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-graduation-cap" style="margin-right: 5px;"></i> Google Scholar
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Google Scholar - No data available</span>
                    </div>

                    <!-- Google Search -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row"
                        :href="mylink_google(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-search" style="margin-right: 5px;"></i> Google Search
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Google Search - No data available</span>
                    </div>

                    <!-- AI-Powered Insight -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                        AI-Powered Insight
                      </h4>
                    </div>

                    <!-- ChatGPT -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row"
                        href="#"
                        @click.prevent="openChatGPT(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-robot" style="margin-right: 5px;"></i> ChatGPT
                      </a>
                      <span v-else style="color: gray; font-style: italic;">ChatGPT - No data available</span>
                    </div>

                    <!-- Clipboard Shortcuts -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #006699; font-weight: bold;">
                        Clipboard Shortcuts
                      </h4>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.gene_symbol"
                        href="#"
                        @click.prevent="copyToClipboard_gene(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.gene_symbol }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No data available</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.chrom && scope.row.pos && scope.row.ref && scope.row.alt"
                        href="#"
                        @click.prevent="copyToClipboard_coordinates_var(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.chrom }}-{{ scope.row.pos }}-{{ scope.row.ref }}-{{ scope.row.alt }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No coordinates</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.chrom && scope.row.pos"
                        href="#"
                        @click.prevent="copyToClipboard_coordinates_igv(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.chrom }}:{{ scope.row.pos }}-{{ scope.row.pos }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No coordinates</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.hgvsc_full"
                        href="#"
                        @click.prevent="copyToClipboard_hgvsc_full(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.hgvsc_full }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No HGVSc</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.feature && scope.row.hgvsp"
                        href="#"
                        @click.prevent="copyToClipboard_hgvsp(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.feature }}:{{ scope.row.hgvsp }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No HGVSp</span>
                    </div>

                    <!-- HGVSc + HGVSp -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.hgvsc_full && scope.row.hgvsp"
                        href="#"
                        @click.prevent="copyToClipboard_hgvsc_hgvsp(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ formatCombinedHgvscHgvsp(scope.row) }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No HGVSc/HGVSp</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.a_891"
                        href="#"
                        @click.prevent="copyToClipboard_dbsnp(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.a_891 }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No dbSNP</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && (scope.row.a_15 || scope.row.a_17 || scope.row.a_16)"
                        href="#"
                        @click.prevent="copyToClipboard_proteinImpact(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        Protein: {{ scope.row.a_15 || '-' }}, Codons: {{ scope.row.a_17 || '-' }}, AA: {{ scope.row.a_16 || '-' }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No protein info</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && (scope.row.a_13 || scope.row.a_14)"
                        href="#"
                        @click.prevent="copyToClipboard_cdnaCds(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        cDNA: {{ scope.row.a_13 || '-' }}, CDS: {{ scope.row.a_14 || '-' }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No cDNA/CDS</span>
                    </div>

                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.a_501"
                        href="#"
                        @click.prevent="copyToClipboard_cosmic(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.a_501 }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No COSMIC ID</span>
                    </div>

                  </div>
                </template>

                <span style="cursor: pointer; text-decoration: underline; color: blue;">
                  Links
                </span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column key="hgvsc"
            prop="hgvsc"
            label="HGVSc / HGVSp"
            min-width="165"
            align="center"
            >
            <template v-if="scope.row.hgvsc > ''" slot-scope="scope">
                <a :href="mylink_hgvsc(scope.row)" target="_blank">{{ scope.row.hgvsc }}</a> <br /> {{ scope.row.hgvsp }}
            </template>
          </el-table-column>

          <el-table-column
            key="freq"
            prop="freq"
            label="VAF"
            min-width="65"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Variant Allele Frequency (VAF): Proportion of alternate allele reads at this site."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">VAF</span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                effect="light"
                :open-delay="200"
                popper-class="custom-tooltip"
                >
                <template #content>
                  <span style=""> {{ scope.row.vaf_f }} / {{ scope.row.vaf_r }} </span>
                </template>
                <span> {{ scope.row.freq }} </span>
              </el-tooltip>
            </template>

          </el-table-column>

          <el-table-column
            key="dp"
            prop="dp"
            label="Total DP"
            min-width="90"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Read Depth (DP): Total number of reads covering the variant site."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Total DP</span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                effect="light"
                :open-delay="200"
                popper-class="custom-tooltip"
                >
                <template #content>
                  <span v-if="scope.row.sor === null" style=""> SOR = NA </span>
                  <span v-else style=""> SOR = {{ scope.row.sor }} </span>
                </template>
                <span> {{ scope.row.rd + scope.row.ad }} </span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="ad"
            prop="ad"
            label="Ref : Alt DP"
            min-width="110"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Ref : Alt DP: Read depth for reference (Ref) and alternate (Alt) alleles at this site."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Ref : Alt DP</span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              {{ scope.row.rd }} : {{ scope.row.ad }}
            </template>
          </el-table-column>

          <el-table-column
            key="variant_class"
            prop="variant_class"
            label="Type"
            min-width="90"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">

              <!-- SNV -->
              <el-tag
                v-if="scope.row.variant_class === 'SNV'"
                size="mini"
                type="info"
              >
                {{ scope.row.variant_class }}
              </el-tag>

              <!-- deletion / DEL -->
              <el-tag
                v-else-if="scope.row.variant_class === 'deletion' || scope.row.variant_class === 'DEL'"
                size="mini"
                type="danger"
              >
                {{ scope.row.variant_class }}
              </el-tag>

              <!-- insertion / INS -->
              <el-tag
                v-else-if="scope.row.variant_class === 'insertion' || scope.row.variant_class === 'INS'"
                size="mini"
                type="success"
              >
                {{ scope.row.variant_class }}
              </el-tag>

              <!-- fallback pro ostatní typy, např. substitution, MNV, complex apod. -->
              <el-tag
                v-else
                size="mini"
                type="warning"
              >
                {{ scope.row.variant_class || 'NA' }}
              </el-tag>

              <br v-if="scope.row.split_reads" />

              <el-tag
                v-if="scope.row.split_reads"
                size="mini"
                type="info"
              >
                SR
              </el-tag>

            </template>
          </el-table-column>

          <el-table-column
            key="consequence"
            prop="consequence"
            label="Consequence"
            width="185"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.consequence"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <template #content>
                  <div style="color: black; max-width: 360px;">
                    <div style="margin-bottom: 0;">
                      <b>Consequence:</b><br />
                      {{ scope.row.consequence }}
                    </div>
                  </div>
                </template>

                <el-tag
                  size="mini"
                  :style="getConsequenceTagStyle(scope.row.consequence)"
                >
                  {{ shortenConsequence(scope.row.consequence) }}
                </el-tag>
              </el-tooltip>

              <span v-else style="color: gray; font-style: italic;">
                NA
              </span>
            </template>
          </el-table-column>

          <el-table-column
            key="filter_text"
            prop="filter_text"
            label="Var Qual"
            min-width="78"
            align="center"
            >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; justify-content: center;">
                <span>
                  {{ scope.row.filter_text }}
                </span>
                <el-tooltip
                  v-if="scope.row.filter.length > 0"
                  placement="top"
                  effect="light"
                  :open-delay="500"
                >
                  <template #content>
                    <div>
                      <p v-for="one in scope.row.filter" :key="one">
                        {{ d_filter[one] }}
                      </p>
                    </div>
                  </template>
                  <span
                    style="cursor: help; margin-left: 5px; color: #ff9800; font-weight: bold;"
                  >
                    ?
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="gt"
            prop="gt"
            label="GT"
            min-width="65"
            align="center"
            sortable="custom"
            >
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.het === 1">HET</span>
              <span v-else-if="scope.row.hom === 1">HOM</span>
              <span v-else> - </span>
            </template> -->
          </el-table-column>

          <el-table-column
            key="a_44"
            prop="a_44"
            label="MAX AF"
            min-width="110"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Maximum observed allele frequency in 1000 Genomes, ESP, and gnomAD."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">MAX AF</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="impact"
            prop="impact"
            label="Impact"
            min-width="95"
            align="center"
            sortable="custom"
            >
            <!-- Header with tooltip -->
            <template #header>
              <el-tooltip
                content="Impact modifier for the consequence type. Classifications include HIGH, MODERATE, LOW, and MODIFIER."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Impact</span>
              </el-tooltip>
            </template>

            <!-- Row content with dynamic coloring -->
            <template slot-scope="scope">
              <a
                :href="'https://www.ensembl.org/info/genome/variation/prediction/predicted_data.html'"
                target="_blank"
                :style="{
                  color: getImpactColor(scope.row.impact),
                  fontWeight: 'bold',
                  textDecoration: 'underline'
                }"
              >
                {{ scope.row.impact }}
              </a>
            </template>
          </el-table-column>

          <el-table-column key="pos"
            prop="pos"
            label="Chr:Position"
            min-width="140"
            align="center"
            sortable="custom"
            >
            <template slot-scope="scope">
              <a :href="mylink_pos(scope.row)" target="_blank">{{ scope.row.chrom }}:{{ scope.row.pos }}</a> <br /> <el-link v-if="igv_switch" @click.native="igv_search(scope.row, $event)" icon="icofont-look" class="igv_modra"> IGV </el-link>
            </template>
          </el-table-column>

          <!-- <el-table-column key="a_501"
            prop="a_501"
            label="COSMIC"
            min-width="120"
            align="center"
            >
            <template v-if="scope.row.a_501 > ''" slot-scope="scope">
                <a :href="mylink_cosmic(scope.row)" target="_blank">{{ scope.row.a_501 }}</a>
            </template>
          </el-table-column> -->

          <el-table-column
            key="abq"
            prop="abq"
            label="ABQ"
            min-width="100"
            align="center"
            >
            <template #header>
              <el-tooltip
                content="Alternate Base Phred Quality: A measure of the quality of the alternate (variant) base. Higher is better."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">ABQ</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column key="gene_inheritance"
            prop="gene_inheritance"
            label="Inheritance"
            min-width="100"
            align="center"
            >
          </el-table-column>

          <el-table-column
            key="mutpred"
            prop="mutpred"
            label="Variant"
            min-width="80"
            align="center"
            >
            <template v-if="scope.row.mutpred > ''" slot-scope="scope">
                <a :href="mylink_oncokb(scope.row)" target="_blank">{{ scope.row.mutpred }}</a>
            </template>
          </el-table-column>

          <!-- <el-table-column key="pubmed"
            prop="pubmed"
            label="Pubmed"
            min-width="130"
            align="center"
            sortable="custom"
            >
            <template v-if="scope.row.pubmed > ''" slot-scope="scope">
                <a v-if="scope.row.pubmed > ''" :href="mylink_pubmed(scope.row.pubmed)" target="_blank"> LINK </a>
            </template>
          </el-table-column> -->

          <el-table-column  key="id_var"
            prop="id_var"
            label="DB ID"
            min-width="90"
            align="center"
            sortable="custom"
            >
          </el-table-column>

          <el-table-column key="27"
            :width="85"
            fixed="right"
            class-name="td-actions"
            label="Actions"
            >
            <template slot-scope="props">
              <el-tooltip content="Show all transcripts" placement="top" effect="light" :open-delay="500">
                <el-button type="default" size="sm" icon @click="handle_transcripts( props.$index, props.row, $event)">
                  <i class="icofont-listing-box"></i>
                </el-button>
              </el-tooltip>

              <!-- <el-button type="default" size="sm" icon @click.native="show = !show"> <i class="icofont-listing-box"></i> </el-button>
              <el-button type="default" size="sm" icon @click.native="$igv.browser('two').search('chr1:102987575-102987633')"> <i class="icofont-listing-box"></i> </el-button>
              <el-button type="default" size="sm" icon @click.native="$igv.destroy('two')"> <i class="icofont-listing-box"></i> </el-button> -->

            </template>
          </el-table-column>

        </el-table>
      </el-col>

      <el-col :span="12" :offset="12">
        <el-pagination
          class="pull-right pagination_mezera"
          @size-change="handleSizeChangePage_v"
          @current-change="handleCurrentChangePage_v"
          :current-page.sync="pagination_v.currentPage"
          :page-sizes="pagination_v.perPageOptions"
          :page-size="pagination_v.perPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination_v.total"
          background
          >
        </el-pagination>
      </el-col>

    </el-row>


    <el-dialog :visible.sync="modal_var_interpretation" width="95%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
      <h5 slot="header" class="title title-up"> Change Internal Class: </h5>
      <form @submit.prevent="submit_formdata_change_class">
        <div class="row">
          <div class="col mr-auto ml-auto">
            <el-tabs class="col-md-12" type="card" @tab-click="iclass_tabs" v-model="mytab">
              <el-tab-pane :disabled="!formdata_change_class.pane_a && mytab_origin !== 'change_a'" label="Change value A" name="change_a">
                  <div class="row">
                    <div class="col-md-11 mr-auto ml-auto">
                        <label>Internal Classification A</label>
                        <div class="form-group">
                          <el-select class="select-info"
                                    placeholder="Select value"
                                    v-model="formdata_change_class.class_value_a">
                            <el-option v-for="one in l_iclasses"
                                      class="select-info"
                                      :value="one.id_iclass"
                                      :label="one.iclass"
                                      :key="one.id_iclass">
                            </el-option>
                          </el-select>
                        </div>

                        <label>Description of Change</label>
                          <el-input
                            type="textarea"
                            :rows="4"
                            autosize
                            maxlength="120"
                            v-model="formdata_change_class.description_a"
                            show-word-limit
                          >
                          </el-input>
                    </div>
                  </div>
              </el-tab-pane>

              <el-tab-pane :disabled="!formdata_change_class.pane_b && mytab_origin !== 'change_b'" label="Change value B" name="change_b">
                <div class="row">
                  <div class="col-md-11 mr-auto ml-auto">
                      <label>Internal Classification B</label>
                      <div class="form-group">
                        <el-select class="select-info"
                                  placeholder="Select value"
                                  v-model="formdata_change_class.class_value_b">
                          <el-option v-for="one in l_iclasses"
                                    class="select-info"
                                    :value="one.id_iclass"
                                    :label="one.iclass"
                                    :key="one.id_iclass">
                          </el-option>
                        </el-select>
                      </div>

                      <label>Description of Change</label>
                        <el-input
                          type="textarea"
                          :rows="4"
                          autosize
                          maxlength="120"
                          v-model="formdata_change_class.description_b"
                          show-word-limit
                        >
                        </el-input>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="Variant Comments" name="description">
                <div class="row">
                  <div class="col-md-11 mr-auto ml-auto">
                    <div class="form-group">
                      <textarea type="textarea" :rows="15" class="form-control" placeholder="" v-model="formdata_change_class.description_v"> </textarea>
                    </div>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="History" name="history">
                <el-table
                  :data="ints_history_data"
                  stripe
                  style="width: 100%"
                  >
                  <el-table-column
                    prop="iaa_user_name_a"
                    label="User Name A"
                    width="200"
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="iclass_a"
                    label="IClass A"
                    width="200"
                    align="center"
                    >
                    <template v-if="scope.row.int_sa > 0" slot-scope="scope">
                        <el-button :style="g_iclasses_style(scope.row.int_sa)" size="small">{{ scope.row.iclass_a }}</el-button>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="iaa_user_name_b"
                    label="User Name B"
                    width="200"
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="iclass_b"
                    label="IClass B"
                    width="200"
                    align="center"
                    >
                    <template v-if="scope.row.int_sb > 0" slot-scope="scope">
                        <el-button :style="g_iclasses_style(scope.row.int_sb)" size="small">{{ scope.row.iclass_b }}</el-button>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="made"
                    label="Made"
                    width="180"
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="int_ta"
                    label="Note A"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="int_tb"
                    label="Note B"
                    >
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="Partners" name="partners">
                <el-table
                  :data="ints_partner_data"
                  stripe
                  style="width: 100%"
                  >

                  <el-table-column
                    prop="subject"
                    label="Partner"
                    min-width="300"
                    sortable
                    >
                  </el-table-column>

                  <el-table-column
                    prop="user_a"
                    label="User Name A"
                    min-width="200"
                    sortable
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="t_int_sa"
                    label="IClass A"
                    min-width="180"
                    sortable
                    align="center"
                    >
                    <template v-if="scope.row.int_sa >= 0" slot-scope="scope">
                        <el-button :style="g_iclasses_style(scope.row.int_sa)" size="small">{{ scope.row.t_int_sa }}</el-button>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="user_b"
                    label="User Name B"
                    min-width="200"
                    sortable
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="t_int_sb"
                    label="IClass B"
                    min-width="180"
                    sortable
                    align="center"
                    >
                    <template v-if="scope.row.int_sb >= 0" slot-scope="scope">
                        <el-button :style="g_iclasses_style(scope.row.int_sb)" size="small">{{ scope.row.t_int_sb }}</el-button>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="made"
                    label="Made"
                    min-width="200"
                    sortable
                    align="center"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="int_ta"
                    label="Note A"
                    min-width="300"
                    >
                  </el-table-column>

                  <el-table-column
                    prop="int_tb"
                    label="Note B"
                    min-width="300"
                    >
                  </el-table-column>
                </el-table>
              </el-tab-pane>

            </el-tabs>
          </div>
        </div>

        <div class="row">
          <div class="col-md-11 mr-auto ml-auto">
            <button type="submit" class="btn btn-info" style="width: 100%">Submit</button>
          </div>
        </div>
      </form>
    </el-dialog>



  </div>



</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  // import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import vars_cufi from 'src/components/Views/Vars_cufi.vue';

  import igv from 'igv';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import FileSaver from 'file-saver';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  export default {
    name: 'vars_table',
    props: {
      global: {
        type: Boolean,
        default: false,
        description: ''
      },
    },
    components: {
      PPagination,
      igv,
      [vars_cufi.name]: vars_cufi,
    },


    data () {
      return {
        selected_vars: [],
        ints_history_data: [],
        ints_partner_data: [],

        modal_var_interpretation: false,

        show: true,

        formdata_np: {
          name: "",
          np_id_workflow: "",
          created_dt: "",
          created_wh: "",

        },

        formdata_change_class: {
          id_var: 0,
          class_value_a: "",
          class_value_b: "",
          description_a: "",
          description_b: "",
          pane_a: false,
          pane_b: false,
          pane_v: false,
          description_v: "",
        },

        blackbox: "",
        files: [],
        mytab: "",
        mytab_origin: "",

        searchQuery_hpo: "",

        grid_size: {
          "S": 300,
          "M": 400,
          "L": 600,
          "XL": 800,
          "XXL": 1100,
          "3XL": 1500,
        },

        slider_marks: {
          0: '0',
          10: '10',
          20: '20',
          30: '30',
          40: '40',
          50: '50',
          60: '60',
          70: '70',
          80: '80',
          90: '90',
          100: '100',
        },

        slider_marks_5: {
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        },

        slider_marks_10: {
          0: '0',
          0.1: '.1',
          0.2: '.2',
          0.3: '.3',
          0.4: '.4',
          0.5: '.5',
          0.6: '.6',
          0.7: '.7',
          0.8: '.8',
          0.9: '.9',
          1: '1',
        },

        var_order_options: [
          {
            value: 1,
            label: 'Clinvar DESC'
          },
          {
            value: 3,
            label: 'Internal Class DESC'
          },
          {
            value: 99,
            label: 'id_var'
          },
        ],
        var_order: 1,

        interpret_id_var: 0,
        interpret_value: 0,

        selects: {
          simple: '',
          multiple: 'ARS'
        },

        l_gt: ["0/1", "1/1"],
        l_impacts: ["LOW", "HIGH", "MODERATE", "MODIFIER"],


        l_search: [
          {
            key: "pos",
            value: "POSITION"
          },
          {
            key: "snp",
            value: "dbSNP"
          },

        ],

        s_search: '',
        searchQuery_v: '',
        propsToSearch_v: [],

        pagination_ff: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },

        tableColumns_ff: [
          {
            prop: 'id_filter',
            label: 'ID',
            minWidth: 50,
            align: "right",
            sortable: false,
          },
          {
            prop: 'name',
            label: 'NAME',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'short_text',
            label: 'SHORT',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'status',
            label: 'S.',
            minWidth: 40,
            align: "center",
            sortable: false,
          },
          {
            prop: 'made',
            label: 'MADE',
            minWidth: 80,
            align: "center",
            sortable: false,
          },

        ],

        pagination_hpo: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5,10],
          total: 0
        },


        tableColumns_transcripts: [
          {
            prop: 'feature',
            label: 'Feature',
            minWidth: 130,
            align: "center",
            sortable: false,
          },
          {
            prop: 'hgvsc',
            label: 'HGVSc',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'hgvsp',
            label: 'HGVSp',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'exon',
            label: 'Exon',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_10',
            label: 'Intron',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'impact',
            label: 'Impact',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'consequence',
            label: 'Conseq',
            minWidth: 160,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_13',
            label: 'cDNA',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_14',
            label: 'CDS',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_15',
            label: 'Protein',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_16',
            label: 'Amino acids',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_17',
            label: 'Codons',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_19',
            label: 'Distance',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'er',
            label: 'ER',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
        ],

      }
    },

    computed: {
      ...mapState({
        vars: state => state.vars,
        f_filters: state => state.f_filters,
        u_filters: state => state.u_filters,
        hpo: state => state.hpo,
        l_gene: state => state.l_gene,
        l_consequences: state => state.l_consequences,
        l_features: state => state.l_features,
        l_clinvars: state => state.l_clinvars,
        l_clinvar_dns: state => state.l_clinvar_dns,
        l_iclasses: state => state.l_iclasses,
        d_acmg_sigs: state => state.d_acmg_sigs,
        d_a_cols: state => state.d_a_cols,
        d_filter: state => state.d_filter,

        cufi: state => state.cufi,
        cufi_yes: state => state.cufi_yes,
        id_project: state => state.id_project,
        id_workflow: state => state.id_workflow,
        id_examination: state => state.id_examination,
        selected_exams: state => state.selected_exams,
        pagination_v: state => state.pagination_v,
        sorting_v: state => state.sorting_v,
        loading_v: state => state.loading_v,

        vars_order: state => state.vars_order,
        vars_selected: state => state.vars_selected,

        user_setup: state => state.user_setup,

        pan_new_project: state => state.pan_new_project,
        pan_project: state => state.pan_project,

        transcripts: state => state.transcripts,
        igv_on: state => state.igv_on,

        token: state => state.token,
        user: state => state.user,
        id_biorole: state => state.id_biorole,
        subject: state => state.subject,
        application: state => state.application,
        app: state => state.app,
        rapp: state => state.rapp,
        app_version: state => state.app_version,
        modal_acmg: state => state.modal_acmg,
        acmg_data: state => state.acmg_data,


      }),

      ...mapGetters({
        g_gene: 'g_gene',
        g_examination: 'g_examination',
        g_examination_export: 'g_examination_export',
        g_examination_selected: 'g_examination_selected',
        g_project: 'g_project',
        g_iclasses: 'g_iclasses',
        g_iclasses_style: 'g_iclasses_style',

      }),


      pagedData_v () {
        return this.vars.slice(this.from_v, this.to_v)
      },

      vars_mydata () {
        if (!this.searchQuery_v) {
          return this.pagedData_v
        }
        let result = this.vars
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_v) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_v)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_v.total = result.length
        return result.slice(this.from_v, this.to_v)
      },


      vars_data () {
        if (!this.searchQuery_v) {
          this.pagination_v.total = this.vars.length
          return this.pagedData_v
        }
        let result = this.vars
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_v) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_v)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_v.total = result.length
        return result.slice(this.from_v, this.to_v)
      },


      to_v () {
        let highBound = this.from_v + this.pagination_v.perPage
        if (this.total_v < highBound) {
          highBound = this.total_v
        }
        return highBound
      },

      from_v () {
        return this.pagination_v.perPage * (this.pagination_v.currentPage - 1)
      },

      total_v () {
        this.pagination_v.total = this.vars.length
        return this.vars.length
      },


      pagedData_ff () {
        return this.f_filters.slice(this.from_ff, this.to_ff)
      },

      f_filters_data () {
        if (!this.searchQuery_ff) {
          this.pagination_ff.total = this.f_filters.length
          return this.pagedData_ff
        }
        let result = this.f_filters
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_ff) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_ff)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_ff.total = result.length
        return result.slice(this.from_ff, this.to_ff)
      },

      to_ff () {
        let highBound = this.from_ff + this.pagination_ff.perPage
        if (this.total_ff < highBound) {
          highBound = this.total_ff
        }
        return highBound
      },

      from_ff () {
        return this.pagination_ff.perPage * (this.pagination_ff.currentPage - 1)
      },

      total_ff () {
        this.pagination_ff.total = this.f_filters.length
        return this.f_filters.length
      },

      pagedData_hpo () {
        return this.hpo.slice(this.from_hpo, this.to_hpo)
      },

      hpo_data () {
        if (!this.searchQuery_hpo) {
          this.pagination_hpo.total = this.hpo.length
          return this.pagedData_hpo
        }
        let result = this.hpo
          .filter((row) => {
            let isIncluded = false
            let rowValue = row["hpo_term_name"].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery_hpo)) {
              isIncluded = true
            }
            return isIncluded
          })
        this.pagination_hpo.total = result.length
        return result.slice(this.from_hpo, this.to_hpo)
      },

      to_hpo () {
        let highBound = this.from_hpo + this.pagination_hpo.perPage
        if (this.total_hpo < highBound) {
          highBound = this.total_hpo
        }
        return highBound
      },

      from_hpo () {
        return this.pagination_hpo.perPage * (this.pagination_hpo.currentPage - 1)
      },

      total_hpo () {
        this.pagination_hpo.total = this.hpo.length
        return this.hpo.length
      },


      slider_value: {
        get () { return this.$store.state.slider_value; },
        set (value) { this.$store.commit('m_slider_value', value); }
      },


      filter_name: {
        get () { return this.$store.state.ff_name; },
        set (value) { this.$store.commit('m_ff_name', value); }
      },

      filter_description: {
        get () { return this.$store.state.ff_description; },
        set (value) { this.$store.commit('m_ff_description', value); }
      },

      er_switch: {
        get () { return this.$store.state.er_switch; },
        set (value) { this.$store.commit('m_er_switch', value); }
      },

      search_vars_by_select: {
        get () { return this.$store.state.search_vars_by_select; },
        set (value) { this.$store.commit('m_search_vars_by_select', value); }
      },

      search_vars_by_value: {
        get () { return this.$store.state.search_vars_by_value; },
        set (value) { this.$store.commit('m_search_vars_by_value', value); }
      },

      igv_switch: {
        get () { return this.$store.state.igv_switch; },
        set (value) { this.$store.commit('m_igv_switch', value); }
      },

      fastras_freq: {
        get () { return this.$store.state.fastras_freq; },
        set (value) { this.$store.commit('m_fastras_freq', value); }
      },

      var_page: {
        get () { return this.$store.state.var_page; },
        set (value) { this.$store.commit('m_var_page', value); }
      },

      vars_selected_tab: {
        get () { return this.$store.state.vars_selected_tab; },
        set (value) { this.$store.commit('m_vars_selected_tab', value); }
      },

      // modal_interpretation: {
      //   get () { return this.$store.state.modal_interpretation; },
      //   set (value) { this.$store.commit('m_modal_interpretation', value); }
      // },

      modal_transcripts: {
        get () { return this.$store.state.modal_transcripts; },
        set (value) { this.$store.commit('m_modal_transcripts', value); }
      },

      modal_pseudopanels: {
        get () { return this.$store.state.modal_pseudopanels; },
        set (value) { this.$store.commit('m_modal_pseudopanels', value); }
      },

      modal_acmg: {
        get() { return this.$store.state.modal_acmg; },
        set(value) { this.$store.commit('m_modal_acmg', value); }
      },

    },


    methods: {
      ...mapMutations({
        m_slider_value: 'm_slider_value',
        m_er_switch: 'm_er_switch',
        m_igv_switch: 'm_igv_switch',
        m_igv_on: 'm_igv_on',
        m_var_page: 'm_var_page',
        m_ss_gene: 'm_ss_gene',
        m_vars: 'm_vars',
        m_vars_selected_tab: 'm_vars_selected_tab',
        m_vars_order: 'm_vars_order',
        m_vars_selected: 'm_vars_selected',
        m_id_examination: 'm_id_examination',
        m_modal_acmg: 'm_modal_acmg',

        // m_modal_interpretation: 'm_modal_interpretation',
        m_modal_transcripts: 'm_modal_transcripts',
        m_transcripts: 'm_transcripts',
        m_cufi_default: 'm_cufi_default',
        m_cufi_yes: 'm_cufi_yes',
        m_fastras_freq: 'm_fastras_freq',
        m_cufi_default: 'm_cufi_default',
        m_cufi_fastras: 'm_cufi_fastras',
        m_cufi_pro_9: 'm_cufi_pro_9',
        m_cufi_pro_10: 'm_cufi_pro_10',
        m_cufi_pro_17: 'm_cufi_pro_17',
        m_cufi_pro_20: 'm_cufi_pro_20',
        m_cufi_pro_21: 'm_cufi_pro_21',
        m_cufi_pro_29: 'm_cufi_pro_29',
        m_cufi_fastgen_cftr_41: 'm_cufi_fastgen_cftr_41',
        m_vars_export_all: 'm_vars_export_all',
        m_vars_export_my: 'm_vars_export_my',
        m_modal_vars_export: 'm_modal_vars_export',

      }),


      ...mapActions({
        a_varsall: 'a_varsall',
        a_vars: 'a_vars',
        a_vars_badges: 'a_vars_badges',
        a_f_filters: 'a_f_filters',
        a_filter_save: 'a_filter_save',
        a_change_interpretation: 'a_change_interpretation',
        a_anots: 'a_anots',
        a_notify: 'a_notify',
        a_examinations: 'a_examinations',
        a_examinations_refresh: 'a_examinations_refresh',
        a_acmg_data: 'a_acmg_data',
        a_acmg_data_genebe: 'a_acmg_data_genebe',
        a_freq_data: 'a_freq_data',
        a_hpo_get: 'a_hpo_get',
        a_predictors_data: 'a_predictors_data',

      }),


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },


      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      },


      tableRowClassName({row, rowIndex}) {
        if (row.er === 1) {
          return 'success-row';
        } else if (row.er === -1) {
          return 'danger-row';
        } else {
          return 'row_0';
        }
      },


      tableRowClassNameVars({row, rowIndex}) {
        // if (row.var_status === 2) {
        //   return 'info-row';
        // } else if (row.var_status === 1) {
        //   return 'row_0';
        // } else {
        //   return 'row_0';
        // }
        return 'row_0';
      },


      canSelectRow() {
      },


      submit_np() {
      },


      get_iclass (val) {
        let _my_id_class = parseInt(val);
        if (_my_id_class >= 0) {
          let ret = this.l_iclasses.filter(one => (one.id_iclass === _my_id_class))[0];
          if (ret != undefined) {
            return ret["label"];
          } else {
            return "--"
          }
        } else {
            return "---"
        }
      },


      get_iclass_style (val) {
        let _my_id_class = parseInt(val);
        if (_my_id_class >= 0) {
          let ret = this.l_iclasses.filter(one => (one.id_iclass === _my_id_class))[0];
          if (ret != undefined) {
            return ret["style"];
          } else {
            return "--"
          }
        } else {
            return ""
        }
      },


      handle_transcripts( index, row, event ) {
        event.stopImmediatePropagation();
        this.m_transcripts([]);
        this.m_modal_transcripts(true);
        this.a_anots( {"id_var": row.id_var, "er": this.er_switch } );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // console.log(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // let mypayload = { "id_var": tree.id_var, "er": this.cufi.er_switch };
      },


      async handle_igv( event ) {
        if (this.igv_switch) {
          axios.get(process.env.VUE_APP_BE + '/get_igv_id', { withCredentials: true, params: { "id_examination": this.id_examination  }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }, })
              .then(response => {
                let bam_url = process.env.VUE_APP_BE + "/get_bam/" + this.subject.id_subject + "/" + response.data["igv_bam"] + ".bam";
                let bai_url = process.env.VUE_APP_BE + "/get_bai/" + this.subject.id_subject + "/" + response.data["igv_bai"] + ".bam.bai";
                let bam_name = response.data["bam_name"];

                // let bam_url = process.env.VUE_APP_STATIC + "static/278-21B_S12_so_rmdp.bam";
                // let bai_url = process.env.VUE_APP_STATIC + "static/278-21B_S12_so_rmdp.bam.bai";


                var igvDiv = document.getElementById("igv-div");
                var options = {
                    showNavigation: true,
                    showRuler: true,
                    supportQueryParameters: true,
                    reference: {
                      id: "hg38",
                      name: "Human (GRCh38/hg38)",
                      fastaURL: "https://s3.amazonaws.com/igv.broadinstitute.org/genomes/seq/hg38/hg38.fa",
                      indexURL: "https://s3.amazonaws.com/igv.broadinstitute.org/genomes/seq/hg38/hg38.fa.fai",
                      cytobandURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/annotations/cytoBandIdeo.txt.gz",
                      aliasURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/hg38_alias.tab"
                    },
                    locus: "all",
                    loadDefaultGenomes: false,
                    tracks: [
                      {
                        type: "alignment",
                        name: bam_name,
                        format: "bam",
                        url: bam_url,
                        indexURL: bai_url,
                        alignmentRowHeight: 12,
                        samplingWindowSize: 200,
                        height: 500,
                      },
                      {
                        name: "Refseq Genes",
                        url: "https://s3.amazonaws.com/igv.org.genomes/hg38/refGene.sorted.txt.gz",
                        indexURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/refGene.sorted.txt.gz.tbi",
                        order: 1000000,
                        indexed: false,
                        height: 100,
                      },



                      // {
                      //   type: "variant",
                      //   format: "vcf",
                      //   url: process.env.VUE_APP_STATIC + "static/clinvar_20210501.vcf.gz",
                      //   indexURL: process.env.VUE_APP_STATIC + "static/clinvar_20210501.vcf.gz.tbi",
                      //   name: "1KG variants",
                      //   squishedCallHeight: 1,
                      //   expandedCallHeight: 4,
                      //   displayMode: "squished",
                      //   visibilityWindow: 1000
                      // }

                    ]
                };

                igv.createBrowser(igvDiv, options)
                        .then(function (browser) {
                            igv.browser = browser;

                        });

                // igv.loadTrack({
                //     url: bam_url,
                //     indexURL: bai_url,
                //     name: '20S1'
                //     })

              }, error => {
                  console.log(error);
              });

        } else {
          igv.removeBrowser(browser);
        }


        // event.stopImmediatePropagation();
        // this.m_transcripts([]);
        // this.m_modal_transcripts(true);
        // this.a_anots( {"id_var": row.id_var, "er": this.er_switch } );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // console.log(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // let mypayload = { "id_var": tree.id_var, "er": this.cufi.er_switch };

      },


      igv_search(row, event) {
        let sest = row.chrom + ":" + row.pos;
        igv.browser.search(sest);
      },


      submit_formdata_change_class() {
        this.a_change_interpretation( this.formdata_change_class );
        this.modal_var_interpretation = false;
        this.formdata_change_class.description_a = "";
        this.formdata_change_class.description_b = "";
      },


      iclass_tabs(tab, event) {
        if (tab.name == "change_a") {
          // this.formdata_change_class.pane_a = true;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

        } else if (tab.name == "change_b") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = true;
          // this.formdata_change_class.pane_v = false;

        } else if (tab.name == "description") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = true;

          // axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, "what": "description" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
          //     .then(response => {
          //       this.formdata_change_class.description_v = response.data["description_v"]
          //     }, error => {
          //         console.log(error);
          //     });

        } else if (tab.name == "history") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

          axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, "what": "history" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_history_data = response.data["ints_history"]
              }, error => {
                  console.log(error);
              });

        } else if (tab.name == "partners") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

          axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, "what": "partnets" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_history_data = response.data["ints_history"]
              }, error => {
                  console.log(error);
              });

        }
        else {
          this.formdata_change_class.pane_a = false;
          this.formdata_change_class.pane_b = false;
          this.formdata_change_class.pane_v = false;
        }
      },


      show_slider_value() {
        this.a_notify( {message: "Genes were added to Custom Filter"} );
      },


      change_var_page() {

      },


      order_select_change(value) {
        if (this.global) {
          this.m_vars_order(value);
          this.a_vars( { "order": value, "er_switch": this.er_switch, } );
        } else {
          this.m_vars_order(value);
          this.a_vars( { "order": value, "er_switch": this.er_switch, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected": this.vars_selected } );
        }
      },


      add_project(){
        this.m_pan_new_project(true);
        this.m_id_project(0);
      },


      show_click(value){

      },


      select_filter_gene(value){
        this.m_ss_gene(value);
      },


      select_filter(value){
        console.log(value);
      },

      // select_impact(value){
      //   console.log(value);
      //   this.m_cufi_impacts(value);
      // },


      reset_filter(){
        this.m_cufi_default();
      },


      show_vars(){
        this.cufi.cufi_yes = true;
        this.pagination_v.currentPage = 1;
        this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected  } );
      },

      // zmena transcriptu
      show_all_vars(){
        this.cufi.cufi_yes = false;
        this.pagination_v.currentPage = 1;
        this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected  } );
      },


      show_by_bioxsys(){
        if (this.id_workflow === 41) {
          this.m_cufi_fastgen_cftr_41();
        } else if (this.id_workflow === 9) {
          this.m_cufi_pro_9();
        } else if (this.id_workflow === 10) {
          this.m_cufi_pro_10();
        } else if (this.id_workflow === 17) {
          this.m_cufi_pro_17();
        } else if (this.id_workflow === 20) {
          this.m_cufi_pro_20();
        } else if (this.id_workflow === 21) {
          this.m_cufi_pro_21();
        } else if (this.id_workflow === 29) {
          this.m_cufi_pro_29();
        } else if (this.rapp === 'fastras') {
          this.m_cufi_fastras();
        } else {
          this.m_cufi_default();
        }

        this.cufi.cufi_yes = false;
        this.pagination_v.currentPage = 1;
        this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected  } );
      },


      cufi_genes_del(){
          let mykey = "genes";
          let value = [];
          this.$store.commit('m_cufi', {mykey, value});
      },



      mylink_symbol(myvar) {
        return "https://www.genecards.org/cgi-bin/carddisp.pl?gene=" + myvar ;
      },

      mylink_pubmed(pubmed) {
        return "https://pubmed.ncbi.nlm.nih.gov/?term=" + pubmed ;
      },

      mylink_clinsig(row) {
        return "http://www.ncbi.nlm.nih.gov/clinvar/?term=" + row.a_879 + "[alleleid]" ;
      },

      mylink_dbsnp(one) {
        return "http://www.ncbi.nlm.nih.gov/snp/" + one ;
      },

      mylink_varsome(row) {
        return `https://varsome.com/variant/hg38/${row.chrom}-${row.pos}-${row.ref}-${row.alt}` ;
      },

      mylink_varsome_somatic(row) {
        return `https://varsome.com/variant/hg38/${row.chrom}-${row.pos}-${row.ref}-${row.alt}?annotation-mode=somatic` ;
      },

      mylink_genebe(row) {
        return `https://genebe.net/variant/hg38/${row.chrom}:${row.pos}-${row.ref}>${row.alt}`;
      },

      mylink_franklin(row) {
        return `https://franklin.genoox.com/clinical-db/variant/snp/${row.chrom}-${row.pos}-${row.ref}-${row.alt}-hg38`;
      },

      mylink_franklin_somatic(row) {
        return `https://franklin.genoox.com/clinical-db/variant/snpTumor/${row.chrom}-${row.pos}-${row.ref}-${row.alt}-hg38`;
      },

      mylink_oncokb(row) {
        return `https://www.oncokb.org/gene/${row.gene_symbol}/${row.mutpred}`;
      },

      mylink_pos(row) {
        return "http://www.ensembl.org/Homo_sapiens/Location/View?r=" + (row.chrom).substring(3) + ":" + row.pos + "-" + row.pos ;
      },


      mylink_hgvsc(row) {
        return "http://genome.ucsc.edu/cgi-bin/hgTracks?db=hg38&position=" + row.hgvsc_full + "&hgt.out3=submit" ;
      },


      mylink_transcript(row) {
        return "https://www.ncbi.nlm.nih.gov/nuccore/" + row.feature ;
      },


      mylink_cosmic(row) {
        return "https://cancer.sanger.ac.uk/cosmic/search?q=" + row.a_501 ;
      },


      gnomad(row) {
        return `https://gnomad.broadinstitute.org/variant/${row.chrom}-${row.pos}-${row.ref}-${row.alt}?dataset=gnomad_r4` ;
      },


      mylink_clinicaltrials(row) {
        return `https://clinicaltrials.gov/search?term=${row.chrom}:${row.pos}-${row.ref}>${row.alt}`;

      },


      mylink_google_scholar(row) {
        const terms = [];

        if (row.gene_symbol) terms.push(row.gene_symbol); // Gene symbol
        if (row.hgvsc_full) terms.push(row.hgvsc_full); // HGVS
        if (row.a_891) terms.push(`${row.a_891}`); // dbSNP rsID

        const query = encodeURIComponent(terms.join(" "));
        return `https://scholar.google.com/scholar?q=${query}`;
      },


      mylink_google(row) {
        const terms = [];

        if (row.a_891) terms.push(`${row.a_891}`);
        if (row.gene_symbol) terms.push(row.gene_symbol);
        if (row.chrom && row.pos) terms.push(`${row.chrom}:${row.pos}`);
        if (row.hgvsc_full) terms.push(row.hgvsc_full);
        if (row.feature) terms.push(row.feature);

        const query = encodeURIComponent(terms.join(" "));
        return `https://www.google.com/search?q=${query}`;
      },


      mylink_chatgpt(row) {
        const parts = [];

        if (row.a_891) parts.push(`dbSNP: ${row.a_891}`);
        if (row.gene_symbol) parts.push(`Gene: ${row.gene_symbol}`);
        if (row.chrom && row.pos) parts.push(`Genomic position: ${row.chrom}:${row.pos}`);
        if (row.hgvsc_full) parts.push(`HGVS: ${row.hgvsc_full}`);

        const query = encodeURIComponent(
          `What is known about this variant? ${parts.join(", ")}`
        );

        return `https://chat.openai.com/chat?prompt=${query}`;
      },


      mylink_pharmgkb(row) {
        return `https://www.pharmgkb.org/search?query=${row.gene_symbol}`;
      },



      alertuj(mytext) {
        if (mytext === 1) {
          alert(mytext + " - Benign");
        } else if (mytext === 2) {
          alert(mytext + " - Likely benign");
        } else if (mytext === 3) {
          alert(mytext + " - Uncertain significance");
        } else if (mytext === 4) {
          alert(mytext + " - Likely pathogenic");
        } else if (mytext === 5) {
          alert(mytext + " - Pathogenic");
        } else {
          alert(mytext);
        }
      },


      click_modal_interpretation ( id_var, myvalue, mytype, descr_v ) {
        this.formdata_change_class.id_var = id_var;
        this.formdata_change_class.description_a = "";
        this.formdata_change_class.description_b = "";

        axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, "what": "description" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
            .then(response => {
              this.formdata_change_class.description_v = response.data["description_v"]
              this.formdata_change_class.class_value_a = response.data["int_sa"]
              this.formdata_change_class.class_value_b = response.data["int_sb"]

              if ( mytype == "a") {
                this.mytab = "change_a";
                this.mytab_origin = "change_a";
                this.formdata_change_class.pane_a = true;
                this.formdata_change_class.pane_b = false;
                this.formdata_change_class.pane_v = true;

              } else if ( mytype == "b") {
                this.mytab = "change_b";
                this.mytab_origin = "change_b";
                this.formdata_change_class.pane_a = false;
                this.formdata_change_class.pane_b = true;
                this.formdata_change_class.pane_v = true;
              }

              this.modal_var_interpretation = true;

              axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, "what": "history" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
                  .then(response => {
                    this.ints_history_data = response.data["ints_history"]
                  }, error => {
                      console.log(error);
                  });

            }, error => {
                console.log(error);
            });


        // this.ints_history_data = [];
      },


      popover_items ( mydata ) {
        let myitems = []
        for (let i of mydata.split(',')) {
          myitems.push( i.replace(/_/g, " ") );
        }
        return "<ul><li>" + myitems.join("</li><li>") + "</li></ul>";
      },


      search_vars_by( event ) {
        event.stopImmediatePropagation();
        if (this.search_vars_by_select === "") {
          this.$alert('Select item for filtering first.', 'WRONG.', {
            confirmButtonText: 'OK',
          });
        } else {
          this.pagination_v.currentPage = 1;

          if (this.vars_selected_tab === "all") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "default") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "presel") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "sign") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          }

        }
      },


      search_vars_all( event ) {
        event.stopImmediatePropagation();
        this.search_vars_by_select = "";
        this.search_vars_by_value = "";

        if (this.vars_selected_tab === "all") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "selected": this.vars_selected } );
        } else {
          this.m_cufi_yes(true);
          this.cufi.cufi_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      sign_out_vars (event) {
        event.stopImmediatePropagation();

        if (this.selected_vars.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants signed out',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                this.a_examinations_refresh( {"id_project": this.id_project} );

                if (this.vars_selected_tab === "all") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "default") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "presel") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "sign") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variant(s) selected to be signed out.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      sign_out_vars_reset (event) {
        event.stopImmediatePropagation();

        axios.put(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
            .then(response => {
              this.$notify({
                title: 'INFO',
                message: 'Successful variant reset',
                type: 'success',
                position: 'top-right',
              });

              if (this.vars_selected_tab === "all") {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
              } else if (this.vars_selected_tab === "default") {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
              } else if (this.vars_selected_tab === "presel") {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
              } else if (this.vars_selected_tab === "sign") {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
              } else {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
              }

              this.a_examinations_refresh( {"id_project": this.id_project} );
            }, error => {
                console.log(error);
            });
      },


      sign_out_no_vars (event) {
        event.stopImmediatePropagation();

        axios.patch(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
            .then(response => {
              this.$notify({
                title: 'INFO',
                message: 'Sign-out without variants was successful',
                type: 'info',
                position: 'top-right',
              });

              this.a_examinations_refresh( {"id_project": this.id_project} );
            }, error => {
                console.log(error);
            });

      },


      preselect_vars (event) {
        event.stopImmediatePropagation();

        if (this.selected_vars.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/preselect_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants are moved to Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "all") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "default") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "presel") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "sign") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variants are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      unpreselect_vars (event) {
        event.stopImmediatePropagation();

        if (this.selected_vars.length > 0) {
          axios.put(process.env.VUE_APP_BE + '/preselect_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants are removed from Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "all") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "default") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "presel") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "cufi": this.cufi, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "sign") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "cufi": this.cufi, "selected": this.vars_selected } );
                } else {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variants are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      make_report_vars (event, sample_id) {
        event.stopImmediatePropagation();
        var my_filename = sample_id.replace(" ", "_").replace("-", "_") + "_report.pdf"
        axios.post(process.env.VUE_APP_BE + '/make_report_vars', { "id_examination": this.id_examination, "app_version": this.app_version, }, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'blob', })
            .then(response => {
                    var blob = new Blob([response.data]);
                    FileSaver.saveAs(blob, my_filename);
            }, error => {
                console.log(error);
                this.$notify({
                  title: 'INFO',
                  message: "Report can't be created.",
                  type: 'warning',
                  position: 'top-right',
                });
            });

      },



      export_setup_cols(event){
        event.stopImmediatePropagation();

        axios.get(process.env.VUE_APP_BE + '/vars_export', { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_vars_export_all( response.data["var_cols"] );
            this.m_vars_export_my( response.data["my_var_cols"] );

            this.m_modal_vars_export( true );

          }, error => {
            console.log(error);
          });
      },


      vars_export_save(event){
        event.stopImmediatePropagation();

        axios.post(process.env.VUE_APP_BE + '/vars_export', {my_var_cols: this.vars_export_my}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_modal_vars_export( false );
            this.$notify({
              title: 'INFO',
              message: 'Export settings saved',
              type: 'success',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      export_all_vars(event){
        event.stopImmediatePropagation();
        this.a_vars( { "export": 2, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "selected": this.vars_selected } );
      },


      export_grid_vars(event){
        event.stopImmediatePropagation();

        if (["default", "custom"].includes(this.vars_selected_tab)) {
          this.a_vars( { "export": 1, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
        } else {
          this.a_vars( { "export": 1, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        }
      },



     click_acmg (event, id_var) {
        event.stopImmediatePropagation();
        this.a_acmg_data( id_var );
      },


      click_acmg_genebe (event, id_var) {
        event.stopImmediatePropagation();
        this.a_acmg_data_genebe( id_var );
      },


      click_freq_proj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants in current project";
        this.a_freq_data( {"row": row, "which": "proj"} );
      },


      click_freq_subj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants";
        this.a_freq_data( {"row": row, "which": "subj"} );
      },


      click_modal_predictors (event, id_var) {
        event.stopImmediatePropagation();
        this.a_predictors_data( id_var );
      },


      // setCurrent(row) {
      //   this.$refs.singleTable.setCurrentRow(row);
      // },
      // handleCurrentChange_p(val) {
      //   if (val && val.id_project > 0) {
      //     this.m_id_project(val.id_project);
      //     this.m_id_examination(0);
      //     this.m_pan_project(true);
      //     // this.a_examinations(val.id_project);
      //     this.project_name = val.name;
      //   } else {
      //     this.m_id_project(0);
      //     this.m_id_examination(0);
      //     this.m_pan_project(false);
      //     this.project_name = "";
      //   }
      // },

      // handleCurrentChange_e(val) {
      //   if (val && val.id_examination > 0) {
      //     this.m_id_examination(val.id_examination);
      //     this.a_vars( {"order": 1, "id_examination": val.id_examination} );
      //   } else {
      //     this.m_id_examination(0);
      //   }
      // },

      handleCurrentChange_v(val) {
        // console.log(val);
      },


      handleCurrentChangePage_v(val) {
        // console.log(this.selected_exams);
        this.pagination_v.currentPage = val;

        if (this.vars_selected_tab === "all") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": val, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": val, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "selected": this.vars_selected } );
        } else {
          this.m_cufi_yes(true);
          this.cufi.cufi_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": val, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      handleSizeChangePage_v(val) {
        // console.log(this.selected_exams);
        this.pagination_v.perPage = val;

        if (this.vars_selected_tab === "all") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          this.m_cufi_yes(false);
          this.cufi.cufi_yes = false;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "selected": this.vars_selected } );
        } else {
          this.m_cufi_yes(true);
          this.cufi.cufi_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "totalPages": this.pagination_v.total, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      handleSelectionChange_v(val) {
        // event.stopImmediatePropagation();
        this.selected_vars = val;
      },


      handleSortChange_v(val) {
        // console.log(this.selected_exams);

        // event.stopImmediatePropagation();
        // console.log(val);
        this.pagination_v.currentPage = 1;
        this.sorting_v.prop = val.prop;
        this.sorting_v.ord = val.order;

        if (this.vars_selected_tab === "all") {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "custom") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },



      toggleSelection_v(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.varsTable.toggleRowSelection_v(row);
          });
        } else {
          this.$refs.varsTable.clearSelection();
        }
      },


      handleCurrentChange_ff(val) {
        if (val && val.id_filter > 0) {
          console.log(val);
          // this.a_examinations(val.id_examination);
        } else {
          console.log(val);
          // this.m_i_examination(0);
        }
      },


      handleCurrentChange_hpo(val) {v
        let skuplek = [];

        if (val) {
          for (let a of this.cufi.genes.values()) {
            skuplek.push(a);
          }
          for (let s of val.genelist) {
            if (!(skuplek.includes(s))) {
              skuplek.push(s);
            }
          }
          skuplek.sort();
          let mykey = "genes";
          let value = skuplek;
          this.$store.commit('m_cufi', {mykey, value});
        }
        this.a_notify( {message: "Genes were added to Filter"} );

        // axios.post(process.env.VUE_APP_BE + '/cufi', {cufi: this.cufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
        //   .then(response => {
        //     this.m_d_cufis( response.data["d_cufis"] );
        //     this.m_l_cufis( response.data["l_cufis"] );

        //     this.$notify({
        //       title: 'INFO',
        //       message: 'Filter was saved',
        //       type: 'success',
        //       position: 'top-right',
        //     });
        //   }, error => {
        //     console.log(error);
        //   });

      },


      inputFile: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          console.log('response', newFile.response)
          if (newFile.xhr) {
            //  Get the response status code
            console.log('status', newFile.xhr.status)
          }
        }
      },


      watch_rapp () {
        if (this.rapp === "fastras") {
          this.user_setup.vars_grid_size = "S";
        } else {
          this.user_setup.vars_grid_size = "L";
        }
      },


      watch_id_examination (newid, oldid) {
        if (newid !== oldid) {
          if (this.igv_switch) {
            this.m_igv_switch(false);
          }
        }
      },

      // watch_selected_exams (newid, oldid) {
      //   if (newid.length > 0) {
      //       this.m_igv_switch(false);
      //   } else {
      //     this.m_igv_switch(true);
      //   }
      // },


      getImpactColor(impact) {
        switch (impact) {
          case 'HIGH':
            return 'red'; // High impact is red
          case 'MODERATE':
            return 'orange'; // Moderate impact is orange
          case 'LOW':
            return 'green'; // Low impact is green
          case 'MODIFIER':
            return 'blue'; // Modifier impact is blue
          default:
            return 'black'; // Fallback color for undefined impact
        }
      },

        shortenConsequence(consequence) {
          if (!consequence) {
            return ''
          }

          const shortLabels = {
            '3 prime UTR variant': '3′ UTR',
            '5 prime UTR variant': '5′ UTR',
            'splice polypyrimidine tract variant': 'splice PPT',
            'splice donor region variant': 'splice donor region',
            'splice donor 5th base variant': 'splice donor 5th base',
            'splice acceptor variant': 'splice acceptor',
            'splice donor variant': 'splice donor',
            'splice region variant': 'splice region',
            'missense variant': 'missense',
            'synonymous variant': 'synonymous',
            'frameshift variant': 'frameshift',
            'stop gained': 'stop gained',
            'stop lost': 'stop lost',
            'start lost': 'start lost',
            'inframe deletion': 'inframe del',
            'inframe insertion': 'inframe ins',
            'intron variant': 'intron',
            'upstream gene variant': 'upstream',
            'downstream gene variant': 'downstream',
            'intergenic variant': 'intergenic',
            'non coding transcript variant': 'non-coding transcript',
            'non coding transcript exon variant': 'non-coding exon',
            'coding sequence variant': 'coding seq.',
            'protein altering variant': 'protein altering'
          }

          return shortLabels[consequence] || consequence
        },

      normalizeConsequence(consequence) {
        if (!consequence) {
          return ''
        }

        return consequence
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '_')
      },

      getConsequenceImpact(consequence) {
        const normalizedConsequence = this.normalizeConsequence(consequence)

        const impacts = {
          // HIGH
          transcript_ablation: 'HIGH',
          splice_acceptor_variant: 'HIGH',
          splice_donor_variant: 'HIGH',
          stop_gained: 'HIGH',
          frameshift_variant: 'HIGH',
          stop_lost: 'HIGH',
          start_lost: 'HIGH',
          transcript_amplification: 'HIGH',
          feature_elongation: 'HIGH',
          feature_truncation: 'HIGH',

          // MODERATE
          inframe_insertion: 'MODERATE',
          inframe_deletion: 'MODERATE',
          missense_variant: 'MODERATE',
          protein_altering_variant: 'MODERATE',

          // LOW
          splice_donor_5th_base_variant: 'LOW',
          splice_region_variant: 'LOW',
          splice_donor_region_variant: 'LOW',
          splice_polypyrimidine_tract_variant: 'LOW',
          incomplete_terminal_codon_variant: 'LOW',
          start_retained_variant: 'LOW',
          stop_retained_variant: 'LOW',
          synonymous_variant: 'LOW',

          // MODIFIER
          coding_sequence_variant: 'MODIFIER',
          mature_mirna_variant: 'MODIFIER',
          '5_prime_utr_variant': 'MODIFIER',
          '3_prime_utr_variant': 'MODIFIER',
          non_coding_transcript_exon_variant: 'MODIFIER',
          intron_variant: 'MODIFIER',
          nmd_transcript_variant: 'MODIFIER',
          non_coding_transcript_variant: 'MODIFIER',
          coding_transcript_variant: 'MODIFIER',
          upstream_gene_variant: 'MODIFIER',
          downstream_gene_variant: 'MODIFIER',
          tfbs_ablation: 'MODIFIER',
          tfbs_amplification: 'MODIFIER',
          tf_binding_site_variant: 'MODIFIER',
          regulatory_region_ablation: 'MODIFIER',
          regulatory_region_amplification: 'MODIFIER',
          regulatory_region_variant: 'MODIFIER',
          intergenic_variant: 'MODIFIER',
          sequence_variant: 'MODIFIER'
        }

        return impacts[normalizedConsequence] || 'UNKNOWN'
      },

      getConsequenceStyle(consequence) {
        const impact = this.getConsequenceImpact(consequence)

        if (impact === 'HIGH') {
          return {
            backgroundColor: '#fdecef',
            borderColor: '#f5b5c0',
            color: '#9f1239'
          }
        }

        if (impact === 'MODERATE') {
          return {
            backgroundColor: '#fff1e8',
            borderColor: '#f5c2a7',
            color: '#b45309'
          }
        }

        if (impact === 'LOW') {
          return {
            backgroundColor: '#fff8db',
            borderColor: '#ead98a',
            color: '#7c5e00'
          }
        }

        if (impact === 'MODIFIER') {
          return {
            backgroundColor: '#f4f4f5',
            borderColor: '#d4d4d8',
            color: '#3f3f46'
          }
        }

        return {
          backgroundColor: '#f4f4f5',
          borderColor: '#d4d4d8',
          color: '#3f3f46'
        }
      },


      getConsequenceTagStyle(consequence) {
        return {
          ...this.getConsequenceStyle(consequence),
          maxWidth: '145px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      },

      copyToClipboard_gene(row) {
        if (row.gene_symbol) {
          navigator.clipboard.writeText(row.gene_symbol).then(() => {
            this.$notify({
              title: 'INFO',
              message: 'Gene symbol copied to clipboard!',
              type: 'success',
              position: 'top-right'
            });
          }).catch(() => {
            this.$notify({
              title: 'ERROR',
              message: 'Failed to copy gene symbol to clipboard.',
              type: 'error',
              position: 'top-right'
            });
          });
        } else {
          this.$notify({
            title: 'WARNING',
            message: 'No gene symbol available to copy.',
            type: 'warning',
            position: 'top-right'
          });
        }
      },


      copyToClipboard_coordinates_var(row) {
        if (row.chrom && row.pos && row.ref && row.alt) {
          // Remove 'chr' if it's already included in row.chrom
          const chrom = row.chrom.startsWith('chr') ? row.chrom.slice(3) : row.chrom;
          const coords = `chr${chrom}-${row.pos}-${row.ref}-${row.alt}`;

          navigator.clipboard.writeText(coords).then(() => {
            this.$notify({
              title: 'Copied',
              message: `Coordinates copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },

      copyToClipboard_coordinates_igv(row) {
        if (row.chrom && row.pos) {
          // Avoid double 'chr' if it's already included
          const chrom = row.chrom.startsWith('chr') ? row.chrom : `chr${row.chrom}`;
          const pos = parseInt(row.pos, 10);

          const igvStyle = `${chrom}:${pos}-${pos}`;

          navigator.clipboard.writeText(igvStyle).then(() => {
            this.$notify({
              title: 'Copied',
              message: `IGV-style coordinates copied: ${igvStyle}`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },

      copyToClipboard_hgvsp(row) {
        if (row.feature && row.hgvsp) {
          const text = `${row.feature}:${row.hgvsp}`;
          navigator.clipboard.writeText(text).then(() => {
            this.$notify({
              title: 'Copied',
              message: `HGVSp copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_hgvsc_full(row) {
        if (row.hgvsc_full) {
          navigator.clipboard.writeText(row.hgvsc_full).then(() => {
            this.$notify({
              title: 'Copied',
              message: `HGVSc copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },

      copyToClipboard_cosmic(row) {
        if (row.a_501) {
          navigator.clipboard.writeText(row.a_501).then(() => {
            this.$notify({
              title: 'Copied',
              message: `COSMIC ID copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },

      copyToClipboard_dbsnp(row) {
        if (row.a_891) {
          const rsid = `${row.a_891}`;
          navigator.clipboard.writeText(rsid).then(() => {
            this.$notify({
              title: 'Copied',
              message: `dbSNP copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },

      copyToClipboard_proteinImpact(row) {
        const parts = [];

        if (row.a_15) parts.push(`Protein: ${row.a_15}`);
        if (row.a_17) parts.push(`Codons: ${row.a_17}`);
        if (row.a_16) parts.push(`AA: ${row.a_16}`);

        const text = parts.length > 0 ? parts.join(', ') : 'No protein info available';

        navigator.clipboard.writeText(text).then(() => {
          this.$notify({
            title: 'Copied',
            message: `Copied: ${text}`,
            type: 'success',
            position: 'top-right',
          });
        });
      },

      copyToClipboard_cdnaCds(row) {
        const parts = [];

        if (row.a_13) parts.push(`cDNA: ${row.a_13}`);
        if (row.a_14) parts.push(`CDS: ${row.a_14}`);

        const text = parts.length > 0 ? parts.join(', ') : 'No cDNA/CDS info available';

        navigator.clipboard.writeText(text).then(() => {
          this.$notify({
            title: 'Copied',
            message: `Copied: ${text}`,
            type: 'success',
            position: 'top-right',
          });
        });
      },

      openChatGPT(row) {
        const parts = [];

        if (row.a_891) parts.push(`dbSNP: rs${row.a_891}`);
        if (row.gene_symbol) parts.push(`Gene: ${row.gene_symbol}`);
        if (row.chrom && row.pos) parts.push(`Genomic position: ${row.chrom}:${row.pos}`);
        if (row.hgvsc_full) parts.push(`HGVS: ${row.hgvsc_full}`);

        const prompt = `What is known about this variant? ${parts.join(", ")}`;

        // Copy to clipboard
        navigator.clipboard.writeText(prompt).then(() => {
          this.$message({
            message: 'Prompt copied to clipboard!',
            type: 'success'
          });

          // Open ChatGPT with the prompt pre-filled
          const encoded = encodeURIComponent(prompt);
          const url = `https://chat.openai.com/?model=gpt-4&prompt=${encoded}`;
          window.open(url, '_blank');
        });
      },

      formatCombinedHgvscHgvsp(row) {
        // Bezpečnostní kontroly
        if (!row || !row.hgvsc_full || !row.hgvsp) return '';

        // Příklad hgvsc_full: "NM_005551.5:c.748C>T"
        const cfull = String(row.hgvsc_full);
        const idx = cfull.indexOf(':');

        // Transcript a c.část
        const transcript = idx > -1 ? cfull.slice(0, idx) : cfull;   // "NM_005551.5"
        const cPart      = idx > -1 ? cfull.slice(idx) : '';         // ":c.748C>T"

        // Genní symbol do závorky, pokud je k dispozici
        const gene = row.gene_symbol ? `(${row.gene_symbol})` : '';

        // HGVSp, např. "p.Arg250Trp" – zobrazujeme v závorkách
        const pPart = ` (${row.hgvsp})`;

        // Finální formát: NM_005551.5(KLK2):c.748C>T (p.Arg250Trp)
        return `${transcript}${gene}${cPart}${pPart}`;
      },

      copyToClipboard_hgvsc_hgvsp(row) {
        if (!row || !row.hgvsc_full || !row.hgvsp) {
          this.$notify({
            title: 'WARNING',
            message: 'No HGVSc/HGVSp available to copy.',
            type: 'warning',
            position: 'top-right'
          });
          return;
        }

        const text = this.formatCombinedHgvscHgvsp(row);

        navigator.clipboard.writeText(text).then(() => {
          this.$notify({
            title: 'Copied',
            message: 'HGVSc + HGVSp copied to clipboard.',
            type: 'success',
            position: 'top-right'
          });
        }).catch(() => {
          this.$notify({
            title: 'ERROR',
            message: 'Failed to copy HGVSc + HGVSp.',
            type: 'error',
            position: 'top-right'
          });
        });
      },

      mylink_ucsc_snv_session(row) {
        if (!row || !row.chrom || !row.pos) return "#";

        const chrom = String(row.chrom).startsWith("chr") ? row.chrom : `chr${row.chrom}`;
        const coord = `${chrom}:${row.pos}-${row.pos}`;

        const base = "https://genome.ucsc.edu/cgi-bin/hgTracks";

        const qs =
          "db=hg38" +
          "&lastVirtModeType=default" +
          "&lastVirtModeExtraState=" +
          "&virtModeType=default" +
          "&virtMode=0" +
          "&nonVirtPosition=" +
          "&hgS_doOtherUser=submit" +
          "&hgS_otherUserName=zgtman" +
          "&hgS_otherUserSessionName=Genovesa_SNV_problematic" +
          "&position=" + encodeURIComponent(coord);

        return base + "?" + qs;
      },

      mylink_ucsc_snv_default(row) {
        if (!row || !row.chrom || !row.pos) return "#";

        const chrom = String(row.chrom).startsWith("chr") ? row.chrom : `chr${row.chrom}`;
        const coord = `${chrom}:${row.pos}-${row.pos}`;

        return (
          "https://genome.ucsc.edu/cgi-bin/hgTracks" +
          "?db=hg38" +
          "&lastVirtModeType=default" +
          "&lastVirtModeExtraState=" +
          "&virtModeType=default" +
          "&virtMode=0" +
          "&nonVirtPosition=" +
          "&position=" + encodeURIComponent(coord)
        );
      },

      mylink_ucsc_snv(row) {
        return this.mylink_ucsc_snv_session(row);
      },

    },

    beforeMount () {
      // this.a_vars();
      this.m_vars([]);
      moment.locale("us");
      this.formdata_np.created_dt = moment(Date().toLocaleString()).format('LLL');
      this.a_f_filters();
    },


    created () {

    },


    mounted () {
      // var igvDiv = document.getElementById("igv-div");
      // var options =
      //     {
      //         genome: "hg38",
      //         locus: "chr8:127,736,588-127,739,371",
      //         tracks: [
      //             {
      //                 "name": "HG00103",
      //                 "url": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram",
      //                 "indexURL": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram.crai",
      //                 "format": "cram"
      //             }
      //         ]
      //     };

      //     igv.createBrowser(igvDiv, options)
      //             .then(function (browser) {
      //                 console.log("Created IGV browser");
      //             })


    },


    afterDestroy () {
      this.m_vars([]);
    },


    watch: {
      rapp: {
        handler: 'watch_rapp',
        immediate: true
      },

      id_examination: {
        handler: 'watch_id_examination',
        immediate: true
      },

      // selected_exams: {
      //   handler: 'watch_selected_exams',
      //   immediate: true
      // },

    },


  }
</script>

<style lang="scss" scoped>
  body {
    margin: 0;
  }

  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }

  .btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .el-table {
    // font-size: 13px !important;
    // color: black !important;

  }

  .el-table .cell{
    line-height: 20px !important;
    word-break: break-word !important;
  }

  .el-table td, .el-table th {
    padding: 3px 0 !important;
  }

  .el-table .row_0 {
    background: #e6e6e6 !important;
  }

  .el-table .row_1 {
    background: rgb(243, 245, 152) !important;
  }

  .el-table .row_2 {
    background: rgb(248, 221, 171) !important;
  }

  .el-table .row_3 {
    background: rgb(248, 186, 157) !important;
  }

  .el-table .row_4 {
    background: rgb(197, 248, 208) !important;
  }

  .el-table .row_9 {
    background: rgb(250, 197, 184) !important;
  }



  .el-table .warning-row {
    background: rgb(241, 175, 52) !important;
  }

  .el-table .success-row {
    background: #a7ffb9 !important;
  }

  .el-table .danger-row {
    background: #f34c19 !important;
  }

  .el-table .info-row .el-tabs--border-card {
    background: #ffece8 !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  h4 {
    margin-top: 5px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .table > thead > tr > th, .el-table table > thead > tr > th {
    // font-size: 13px !important;
  }

  .mezera {
    margin-right: 10px !important;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .bottom_margin_5 {
    margin-bottom: 5px;
  }

  .top_margin_10 {
    margin-top: 10px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #e2e4e5 !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #ccfdf3 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
      color: black !important;
      font-weight: 600 !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 18px;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }
  .el-table .cell {
      word-break: break-word;
  }

  .small_label {
      font-size: 10px !important;
      padding-top: 2px !important;
      padding-right: 4px !important;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }

  .pagination_mezera {
    margin-top: 25px !important;
  }

  .caret-wrapper {
    display: block !important;
  }

  .igv_modra {
    color: #409EFF !important;
  }

  .badge_item {
    margin-top: 10px;
    margin-right: 10px;
  }

  .custom-tooltip .el-tooltip__popper {
    background-color: #fff !important; /* Light background for the tooltip */
    border: 1px solid #ddd;            /* Optional: Subtle border around the tooltip */
    padding: 8px;                      /* Padding inside the tooltip */
    font-size: 14px;                   /* Adjust font size */
    color: black;                      /* Ensure the text color is black */
  }

  .custom-tooltip .el-tooltip__content {
    color: black;                      /* Ensure the content text is black */
  }


</style>
